module.exports = __webpack_public_path__ + "img/go5.b78a0d37.png";